module.exports = __webpack_public_path__ + "static/media/bg.566e8daf.jpg";